module.exports = __webpack_public_path__ + "site/img/58.7ef85acf.jpg";